export const sidebarDesktop = [
  {
    id: 1,
    title: 'داشبورد',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M20.04 6.81994L14.28 2.78994C12.71 1.68994 10.3 1.74994 8.78999 2.91994L3.77999 6.82994C2.77999 7.60994 1.98999 9.20994 1.98999 10.4699V17.3699C1.98999 19.9199 4.05999 21.9999 6.60999 21.9999H17.39C19.94 21.9999 22.01 19.9299 22.01 17.3799V10.5999C22.01 9.24994 21.14 7.58994 20.04 6.81994Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18C12.75 18.41 12.41 18.75 12 18.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  // {
  //   id: 2,
  //   title: 'یادآورها',
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         opacity="0.24"
  //         d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V9V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V9V7.5Z"
  //         fill="currentColor"
  //       />
  //       <path d="M17 3.5H7C4.79086 3.5 3 5.29086 3 7.5V9H21V7.5C21 5.29086 19.2091 3.5 17 3.5Z" fill="currentColor" />
  //       <path
  //         opacity="0.32"
  //         fill-rule="evenodd"
  //         clip-rule="evenodd"
  //         d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V2C7.25 1.58579 7.58579 1.25 8 1.25ZM16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V5C16.75 5.41421 16.4142 5.75 16 5.75C15.5858 5.75 15.25 5.41421 15.25 5V2C15.25 1.58579 15.5858 1.25 16 1.25Z"
  //         fill="currentColor"
  //       />
  //       <path
  //         fill-rule="evenodd"
  //         clip-rule="evenodd"
  //         d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75H12.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
  //         fill="currentColor"
  //       />
  //     </svg>
  //   ),
  //   href: '/reminders',
  //   submenu: false,
  //   agent: true,
  //   rsOwner: true,
  // },
  {
    id: 3,
    title: 'مدیریت آگهی‌ها',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M20 8.25V18C20 21 18.21 22 16 22H8C5.79 22 4 21 4 18V8.25C4 5 5.79 4.25 8 4.25C8 4.87 8.24997 5.43 8.65997 5.84C9.06997 6.25 9.63 6.5 10.25 6.5H13.75C14.99 6.5 16 5.49 16 4.25C18.21 4.25 20 5 20 8.25Z"
          fill="currentColor"
        />
        <path
          d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.06997 6.25 8.65997 5.84C8.24997 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z"
          fill="currentColor"
        />
        <path
          d="M12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z"
          fill="currentColor"
        />
        <path
          d="M16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/ads',
    submenu: true,
    agent: true,
    rsOwner: true,
    items: [
      { id: 1, title: 'لیست آگهی', href: '/ads/list' },
      { id: 2, title: 'درج آگهی جدید', href: '/ads/create' },
    ],
  },
  {
    id: 4,
    title: 'لیست مشتریان',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M9.92154 2.57125C11.2077 1.80958 12.7923 1.80958 14.0785 2.57125L18.9215 5.43932C20.2077 6.20099 21 7.6086 21 9.13192V14.8681C21 16.3914 20.2077 17.799 18.9215 18.5607L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.07846 18.5607C3.7923 17.799 3 16.3914 3 14.8681V9.13192C3 7.6086 3.7923 6.20099 5.07846 5.43932L9.92154 2.57125Z"
          fill="currentColor"
        />
        <path
          d="M9.92155 21.4286C11.2077 22.1903 12.7923 22.1903 14.0785 21.4286L18.301 18.928C17.0431 16.698 14.6924 15.1978 12 15.1978C9.30764 15.1978 6.95688 16.698 5.69897 18.928L9.92155 21.4286Z"
          fill="currentColor"
        />
        <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 9 13)" fill="currentColor" />
      </svg>
    ),
    href: '/customers',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  {
    id: 5,
    title: 'مدیریت مشاورین',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M14.08 14.1499C11.29 12.2899 6.73996 12.2899 3.92996 14.1499C2.65996 14.9999 1.95996 16.1499 1.95996 17.3799C1.95996 18.6099 2.65996 19.7499 3.91996 20.5899C5.31996 21.5299 7.15996 21.9999 8.99996 21.9999C10.84 21.9999 12.68 21.5299 14.08 20.5899C15.34 19.7399 16.04 18.5999 16.04 17.3599C16.03 16.1299 15.34 14.9899 14.08 14.1499Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M19.9901 7.3401C20.1501 9.2801 18.7701 10.9801 16.8601 11.2101C16.8501 11.2101 16.8501 11.2101 16.8401 11.2101H16.8101C16.7501 11.2101 16.6901 11.2101 16.6401 11.2301C15.6701 11.2801 14.7801 10.9701 14.1101 10.4001C15.1401 9.4801 15.7301 8.1001 15.6101 6.6001C15.5401 5.7901 15.2601 5.0501 14.8401 4.4201C15.2201 4.2301 15.6601 4.1101 16.1101 4.0701C18.0701 3.9001 19.8201 5.3601 19.9901 7.3401Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M21.99 16.5899C21.91 17.5599 21.29 18.3999 20.25 18.9699C19.25 19.5199 17.99 19.7799 16.74 19.7499C17.46 19.0999 17.88 18.2899 17.96 17.4299C18.06 16.1899 17.47 14.9999 16.29 14.0499C15.62 13.5199 14.84 13.0999 13.99 12.7899C16.2 12.1499 18.98 12.5799 20.69 13.9599C21.61 14.6999 22.08 15.6299 21.99 16.5899Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/agents',
    submenu: true,
    agent: false,
    rsOwner: true,
    items: [
      { id: 1, title: 'لیست مشاورین', href: '/agents/list' },
      { id: 2, title: 'مدیریت دعوتنامه ها', href: '/agents/invations' },
    ],
  },
  {
    id: 6,
    title: 'درخواست ها',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          opacity="0.8"
          d="M20 8V7C20 5.34315 18.6569 4 17 4H14.1975C13.5294 4 12.8805 3.77702 12.3535 3.3664L11.4131 2.6336C10.8862 2.22298 10.2372 2 9.56917 2H7C5.34315 2 4 3.34315 4 5V8H20Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M20.5261 8H3.47403C2.20074 8 1.25163 9.17404 1.51843 10.4191L3.32251 18.8381C3.71771 20.6824 5.34757 22 7.23372 22H16.7664C18.6525 22 20.2824 20.6824 20.6776 18.8381L22.4817 10.4191C22.7485 9.17403 21.7994 8 20.5261 8Z"
          fill="currentColor"
        />
        <g opacity="0.8">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75L12.75 15.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    href: '/requests',
    submenu: false,
    agent: true,
    rsOwner: false,
  },
  {
    id: 7,
    title: 'درخواست های بازدید',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 11C14.33 11 16 12.67 16 15H8C8 12.67 9.67 11 12 11Z"
          fill="currentColor"
        />
        <path
          d="M15 8H17C17.55 8 18 8.45 18 9V11C18 11.55 17.55 12 17 12H15C14.45 12 14 11.55 14 11V9C14 8.45 14.45 8 15 8Z"
          fill="currentColor"
        />
        <path
          d="M7 8H9C9.55 8 10 8.45 10 9V11C10 11.55 9.55 12 9 12H7C6.45 12 6 11.55 6 11V9C6 8.45 6.45 8 7 8Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/visit-requests',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  {
    id: 8,
    title: 'کارت دیجیتال املاک',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
          fill="currentColor"
        />
        <g opacity="0.8">
          <path fillRule="evenodd" clipRule="evenodd" d="M6 6H10V10H6V6ZM7 7H9V9H7V7Z" fill="currentColor" />
          <path fillRule="evenodd" clipRule="evenodd" d="M14 6H18V10H14V6ZM15 7H17V9H15V7Z" fill="currentColor" />
          <path fillRule="evenodd" clipRule="evenodd" d="M6 14H10V18H6V14ZM7 15H9V17H7V15Z" fill="currentColor" />
          <path d="M11 6H13V8H11V6Z" fill="currentColor" />
          <path d="M6 11H8V13H6V11Z" fill="currentColor" />
          <path d="M11 11H13V13H11V11Z" fill="currentColor" />
          <path d="M15 11H17V13H15V11Z" fill="currentColor" />
          <path d="M11 14H13V16H11V14Z" fill="currentColor" />
          <path d="M9 16H15V18H9V16Z" fill="currentColor" />
          <path d="M15 15H16V16H15V15Z" fill="currentColor" />
          <path d="M17 15H18V16H17V15Z" fill="currentColor" />
          <path d="M17 17H18V18H17V17Z" fill="currentColor" />
        </g>
      </svg>
    ),
    href: '/qr-code',
    submenu: false,
    agent: false,
    rsOwner: true,
  },
  {
    id: 11,
    title: 'کارت دیجیتال مشاور',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18H7Z"
          fill="currentColor"
        />
        <path
          d="M18 8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5V9.5C17 9.77614 17.2239 10 17.5 10C17.7761 10 18 9.77614 18 9.5V8.5Z"
          fill="currentColor"
        />
        <path
          d="M18 14.5C18 14.2239 17.7761 14 17.5 14C17.2239 14 17 14.2239 17 14.5V15.5C17 15.7761 17.2239 16 17.5 16C17.7761 16 18 15.7761 18 15.5V14.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/agent-qr-code',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  {
    id: 9,
    title: 'تنظیمات',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M12.9545 3H11.0455C9.99109 3 9.13635 3.80589 9.13635 4.8C9.13635 5.93761 7.91917 6.66087 6.92 6.11697L6.81852 6.06172C5.90541 5.56467 4.73782 5.85964 4.21064 6.72057L3.25609 8.27942C2.72891 9.14034 3.04176 10.2412 3.95487 10.7383C4.95451 11.2824 4.95451 12.7176 3.95487 13.2617C3.04176 13.7588 2.72891 14.8597 3.25609 15.7206L4.21064 17.2794C4.73782 18.1404 5.90541 18.4353 6.81851 17.9383L6.92 17.883C7.91917 17.3391 9.13635 18.0624 9.13635 19.2C9.13635 20.1941 9.99109 21 11.0455 21H12.9545C14.0089 21 14.8636 20.1941 14.8636 19.2C14.8636 18.0624 16.0808 17.3391 17.08 17.883L17.1815 17.9383C18.0946 18.4353 19.2622 18.1403 19.7894 17.2794L20.7439 15.7206C21.2711 14.8596 20.9582 13.7588 20.0451 13.2617C19.0455 12.7176 19.0455 11.2824 20.0451 10.7383C20.9582 10.2412 21.2711 9.14036 20.7439 8.27943L19.7894 6.72058C19.2622 5.85966 18.0946 5.56468 17.1815 6.06174L17.08 6.11698C16.0808 6.66088 14.8636 5.93762 14.8636 4.8C14.8636 3.80589 14.0089 3 12.9545 3Z"
          fill="currentColor"
        />
        <circle opacity="0.8" cx="12" cy="12" r="3" fill="currentColor" />
      </svg>
    ),
    href: 'settings',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  {
    id: 10,
    title: 'مدیریت اشتراک',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M16.7702 18.98H7.23024C6.81024 18.98 6.43024 18.71 6.29024 18.32L2.13024 6.66998C1.80024 5.73998 2.86024 4.94998 3.65024 5.51998L7.65024 8.37998C8.18024 8.75998 8.94024 8.52998 9.17024 7.91998L11.0602 2.87998C11.3802 2.00998 12.6102 2.00998 12.9302 2.87998L14.8202 7.91998C15.0502 8.53998 15.8002 8.75998 16.3402 8.37998L20.3402 5.51998C21.1402 4.94998 22.1902 5.74998 21.8602 6.66998L17.7002 18.32C17.5702 18.71 17.1902 18.98 16.7702 18.98Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M14.5 14.75H9.5C9.09 14.75 8.75 14.41 8.75 14C8.75 13.59 9.09 13.25 9.5 13.25H14.5C14.91 13.25 15.25 13.59 15.25 14C15.25 14.41 14.91 14.75 14.5 14.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/subscription',
    submenu: false,
    agent: false,
    rsOwner: true,
  },
  {
    id: 100,
    title: 'وضعیت بازار',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="16" width="2" height="5" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="7" y="12" width="2" height="9" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="11" y="8" width="2" height="13" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="15" y="4" width="2" height="17" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="19" y="10" width="2" height="11" rx="1" fill="currentColor" opacity="0.7" />
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.5" />
        <path
          d="M4 18L8 14L12 10L16 6L20 10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    href: '/market-status',
    submenu: false,
    agent: true,
    rsOwner: true,
  },
  // {
  //   id: 8,
  //   title: "راهنما",
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         opacity="0.24"
  //         d="M18.3801 12.84V17.77C18.3801 19.04 17.3901 20.4 16.2001 20.8L13.0101 21.86C12.4501 22.05 11.5401 22.05 10.9901 21.86L7.80012 20.8C6.60012 20.4 5.62012 19.04 5.62012 17.77L5.63012 12.84L10.0501 15.72C11.1301 16.43 12.9101 16.43 13.9901 15.72L18.3801 12.84Z"
  //         fill="currentColor"
  //       />
  //       <path
  //         opacity="0.8"
  //         d="M19.9795 6.46L13.9895 2.53C12.9095 1.82 11.1295 1.82 10.0495 2.53L4.02953 6.46C2.09953 7.71 2.09953 10.54 4.02953 11.8L5.62953 12.84L10.0495 15.72C11.1295 16.43 12.9095 16.43 13.9895 15.72L18.3795 12.84L19.7495 11.94V15C19.7495 15.41 20.0895 15.75 20.4995 15.75C20.9095 15.75 21.2495 15.41 21.2495 15V10.08C21.6495 8.79 21.2395 7.29 19.9795 6.46Z"
  //         fill="currentColor"
  //       />
  //     </svg>
  //   ),
  //   href: "/help",
  //   submenu: false,
  //   agent: true,
  //   rsOwner: true,
  // },
];

export const sidebarMobile = [
  {
    id: 1,
    title: 'داشبورد',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M20.0402 6.82L14.2802 2.79C12.7102 1.69 10.3002 1.75 8.79023 2.92L3.78023 6.83C2.78023 7.61 1.99023 9.21 1.99023 10.47V17.37C1.99023 19.92 4.06023 22 6.61023 22H17.3902C19.9402 22 22.0102 19.93 22.0102 17.38V10.6C22.0102 9.25 21.1402 7.59 20.0402 6.82Z"
          fill="currentColor"
        />
        <path
          d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18C12.75 18.41 12.41 18.75 12 18.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/',
    agent: true,
    rsOwner: true,
  },
  {
    id: 2,
    title: 'منو',
    icon: (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.74 2H5.84C3.65 2 2.5 3.15 2.5 5.33V7.23C2.5 9.41 3.65 10.56 5.83 10.56H7.73C9.91 10.56 11.06 9.41 11.06 7.23V5.33C11.07 3.15 9.92 2 7.74 2Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M19.1704 2H17.2704C15.0904 2 13.9404 3.15 13.9404 5.33V7.23C13.9404 9.41 15.0904 10.56 17.2704 10.56H19.1704C21.3504 10.56 22.5004 9.41 22.5004 7.23V5.33C22.5004 3.15 21.3504 2 19.1704 2Z"
          fill="currentColor"
        />
        <path
          d="M19.1704 13.43H17.2704C15.0904 13.43 13.9404 14.58 13.9404 16.76V18.66C13.9404 20.84 15.0904 21.99 17.2704 21.99H19.1704C21.3504 21.99 22.5004 20.84 22.5004 18.66V16.76C22.5004 14.58 21.3504 13.43 19.1704 13.43Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M7.74 13.43H5.84C3.65 13.43 2.5 14.58 2.5 16.76V18.66C2.5 20.85 3.65 22 5.83 22H7.73C9.91 22 11.06 20.85 11.06 18.67V16.77C11.07 14.58 9.92 13.43 7.74 13.43Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: 'menu',
    clickable: true,
    agent: true,
    rsOwner: true,
  },
  {
    id: 3,
    title: 'افزودن',
    icon: (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
          fill="currentColor"
        />
        <path
          d="M16.5 11.25H13.25V8C13.25 7.59 12.91 7.25 12.5 7.25C12.09 7.25 11.75 7.59 11.75 8V11.25H8.5C8.09 11.25 7.75 11.59 7.75 12C7.75 12.41 8.09 12.75 8.5 12.75H11.75V16C11.75 16.41 12.09 16.75 12.5 16.75C12.91 16.75 13.25 16.41 13.25 16V12.75H16.5C16.91 12.75 17.25 12.41 17.25 12C17.25 11.59 16.91 11.25 16.5 11.25Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: 'add',
    clickable: true,
    agent: true,
    rsOwner: true,
  },
  {
    id: 4,
    title: 'مشاورین',
    icon: (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M9.5 2C6.88 2 4.75 4.13 4.75 6.75C4.75 9.32 6.76 11.4 9.38 11.49C9.46 11.48 9.54 11.48 9.6 11.49C9.62 11.49 9.63 11.49 9.65 11.49C9.66 11.49 9.66 11.49 9.67 11.49C12.23 11.4 14.24 9.32 14.25 6.75C14.25 4.13 12.12 2 9.5 2Z"
          fill="currentColor"
        />
        <path
          d="M14.58 14.15C11.79 12.29 7.23996 12.29 4.42996 14.15C3.15996 15 2.45996 16.15 2.45996 17.38C2.45996 18.61 3.15996 19.75 4.41996 20.59C5.81996 21.53 7.65996 22 9.49996 22C11.34 22 13.18 21.53 14.58 20.59C15.84 19.74 16.54 18.6 16.54 17.36C16.53 16.13 15.84 14.99 14.58 14.15Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M20.4904 7.33998C20.6504 9.27998 19.2704 10.98 17.3604 11.21C17.3504 11.21 17.3504 11.21 17.3404 11.21H17.3104C17.2504 11.21 17.1904 11.21 17.1404 11.23C16.1704 11.28 15.2804 10.97 14.6104 10.4C15.6404 9.47998 16.2304 8.09998 16.1104 6.59998C16.0404 5.78998 15.7604 5.04998 15.3404 4.41998C15.7204 4.22998 16.1604 4.10998 16.6104 4.06998C18.5704 3.89998 20.3204 5.35998 20.4904 7.33998Z"
          fill="currentColor"
        />
        <path
          d="M22.4902 16.59C22.4102 17.56 21.7902 18.4 20.7502 18.97C19.7502 19.52 18.4902 19.78 17.2402 19.75C17.9602 19.1 18.3802 18.29 18.4602 17.43C18.5602 16.19 17.9702 15 16.7902 14.05C16.1202 13.52 15.3402 13.1 14.4902 12.79C16.7002 12.15 19.4802 12.58 21.1902 13.96C22.1102 14.7 22.5802 15.63 22.4902 16.59Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/agents/list',
    agent: false,
    rsOwner: true,
  },
  {
    id: 5,
    title: 'دخواست ها',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          opacity="0.8"
          d="M20 8V7C20 5.34315 18.6569 4 17 4H14.1975C13.5294 4 12.8805 3.77702 12.3535 3.3664L11.4131 2.6336C10.8862 2.22298 10.2372 2 9.56917 2H7C5.34315 2 4 3.34315 4 5V8H20Z"
          fill="currentColor"
        />
        <path
          opacity="0.24"
          d="M20.5261 8H3.47403C2.20074 8 1.25163 9.17404 1.51843 10.4191L3.32251 18.8381C3.71771 20.6824 5.34757 22 7.23372 22H16.7664C18.6525 22 20.2824 20.6824 20.6776 18.8381L22.4817 10.4191C22.7485 9.17403 21.7994 8 20.5261 8Z"
          fill="currentColor"
        />
        <g opacity="0.8">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75L12.75 15.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    href: '/requests',
    agent: true,
    rsOwner: false,
  },
  // {
  //   id: 6,
  //   title: 'بازدید',
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         opacity="0.24"
  //         d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
  //         fill="currentColor"
  //       />
  //       <path
  //         opacity="0.8"
  //         d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 11C14.33 11 16 12.67 16 15H8C8 12.67 9.67 11 12 11Z"
  //         fill="currentColor"
  //       />
  //       <path
  //         d="M15 8H17C17.55 8 18 8.45 18 9V11C18 11.55 17.55 12 17 12H15C14.45 12 14 11.55 14 11V9C14 8.45 14.45 8 15 8Z"
  //         fill="currentColor"
  //       />
  //       <path
  //         d="M7 8H9C9.55 8 10 8.45 10 9V11C10 11.55 9.55 12 9 12H7C6.45 12 6 11.55 6 11V9C6 8.45 6.45 8 7 8Z"
  //         fill="currentColor"
  //       />
  //     </svg>
  //   ),
  //   href: '/visit-requests',
  //   agent: true,
  //   rsOwner: true,
  // },

  {
    id: 7,
    title: 'آگهی ها',
    icon: (
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          d="M20.5 8.25V18C20.5 21 18.71 22 16.5 22H8.5C6.29 22 4.5 21 4.5 18V8.25C4.5 5 6.29 4.25 8.5 4.25C8.5 4.87 8.74997 5.43 9.15997 5.84C9.56997 6.25 10.13 6.5 10.75 6.5H14.25C15.49 6.5 16.5 5.49 16.5 4.25C18.71 4.25 20.5 5 20.5 8.25Z"
          fill="currentColor"
        />
        <path
          d="M16.5 4.25C16.5 5.49 15.49 6.5 14.25 6.5H10.75C10.13 6.5 9.56997 6.25 9.15997 5.84C8.74997 5.43 8.5 4.87 8.5 4.25C8.5 3.01 9.51 2 10.75 2H14.25C14.87 2 15.43 2.25 15.84 2.66C16.25 3.07 16.5 3.63 16.5 4.25Z"
          fill="currentColor"
        />
        <path
          d="M12.5 13.75H8.5C8.09 13.75 7.75 13.41 7.75 13C7.75 12.59 8.09 12.25 8.5 12.25H12.5C12.91 12.25 13.25 12.59 13.25 13C13.25 13.41 12.91 13.75 12.5 13.75Z"
          fill="currentColor"
        />
        <path
          d="M16.5 17.75H8.5C8.09 17.75 7.75 17.41 7.75 17C7.75 16.59 8.09 16.25 8.5 16.25H16.5C16.91 16.25 17.25 16.59 17.25 17C17.25 17.41 16.91 17.75 16.5 17.75Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/ads/list',
    agent: true,
    rsOwner: true,
  },
  {
    id: 11,
    title: 'کارت دیجیتال مشاور',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.24"
          d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18H7Z"
          fill="currentColor"
        />
        <path
          d="M18 8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5V9.5C17 9.77614 17.2239 10 17.5 10C17.7761 10 18 9.77614 18 9.5V8.5Z"
          fill="currentColor"
        />
        <path
          d="M18 14.5C18 14.2239 17.7761 14 17.5 14C17.2239 14 17 14.2239 17 14.5V15.5C17 15.7761 17.2239 16 17.5 16C17.7761 16 18 15.7761 18 15.5V14.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    href: '/agent-qr-code',
    agent: false,
    rsOwner: false,
  },
];
